"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../../../BaseComponent");
var HegydCore_1 = require("../../../components/hegyd/hegyd-core/HegydCore");
var sweetalert2_js_1 = require("sweetalert2/dist/sweetalert2.js");
var AddressesSelection = /** @class */ (function (_super) {
    __extends(AddressesSelection, _super);
    function AddressesSelection($view) {
        var _this = _super.call(this, $view) || this;
        _this.bind();
        return _this;
    }
    AddressesSelection.prototype.bind = function () {
        this.initEvents();
    };
    AddressesSelection.prototype.getSelectorAddAddress = function () {
        return 'a#add-address';
    };
    AddressesSelection.prototype.getSelectorEditAddress = function () {
        return 'a.edit-address';
    };
    AddressesSelection.prototype.getSelectorRemoveAddress = function () {
        return "a.destroy-address";
    };
    AddressesSelection.prototype.hideLoader = function () {
        $('.loading').hide();
    };
    AddressesSelection.prototype.initAddressesModal = function (url, loadedCallback) {
        HegydCore_1.default.initRemoteModal('#modal', url, loadedCallback, function () {
            window.location.reload();
        });
    };
    AddressesSelection.prototype.deleteAddress = function ($remove_link) {
        this.askToDelete($remove_link.data('message'), $remove_link.data('button'), function () {
            HegydCore_1.default.sendRequest($remove_link.attr('href'), 'DELETE', {
            // 'return_templates': this.getAllCartTemplate()
            }, function () {
                window.location.reload();
            });
        });
    };
    AddressesSelection.prototype.askToDelete = function (deleteText, buttonText, callback) {
        sweetalert2_js_1.default({
            title: deleteText.title,
            html: deleteText.message,
            allowOutsideClick: true,
            showCancelButton: true,
            closeOnConfirm: false,
            closeOnCancel: true,
            confirmButtonColor: '#ee0000',
            cancelButtonText: buttonText.cancel,
            confirmButtonText: buttonText.confirm,
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve) {
                    if (callback) {
                        callback(resolve);
                    }
                });
            }
        }).then(function () {
            sweetalert2_js_1.default.close();
        });
    };
    AddressesSelection.prototype.initSelect2Countries = function () {
        // @ts-ignore
        $('#country_id').select2({
            language: 'fr',
            ajax: {
                url: '/countries',
                data: function (params) {
                    return {
                        query: params.term
                    };
                },
                processResults: function (data) {
                    var results = [];
                    $.each(data, function (id, entity) {
                        results.push({
                            id: entity.id,
                            text: entity.title
                        });
                    });
                    return { results: results };
                },
                templateResult: function (data) {
                    return data.title;
                }
            },
            initSelection: function (element, callback) {
                var id = $('[name=address_country_id]').val();
                var results = [];
                if (id) {
                    $.ajax("/countries/" + id, {
                        dataType: "json"
                    }).done(function (entity) {
                        if (entity) {
                            var id_1 = entity.id;
                            var text = entity.title;
                            results.push({ id: id_1, text: text });
                        }
                        callback(results);
                    });
                }
                callback(results);
            }
        });
    };
    AddressesSelection.prototype.initSelect2Cities = function () {
        // @ts-ignore
        $('#city_id').select2({
            language: 'fr',
            ajax: {
                url: '/cities',
                data: function (params) {
                    return {
                        query: params.term
                    };
                },
                processResults: function (data) {
                    var results = [];
                    $.each(data, function (id, entity) {
                        var text = entity.name + ' (' + entity.zip + ')';
                        results.push({
                            id: entity.id,
                            text: text
                        });
                    });
                    return { results: results };
                },
                templateResult: function (data) {
                    return data.title;
                }
            },
            initSelection: function (element, callback) {
                var id = $('[name=address_city_id]').val();
                var results = [];
                if (id) {
                    $.ajax("/cities/" + id, {
                        dataType: "json"
                    }).done(function (entity) {
                        if (entity) {
                            var id_2 = entity.id;
                            var text = entity.name + ' (' + entity.zip + ')';
                            results.push({ id: id_2, text: text });
                        }
                        callback(results);
                    });
                }
                callback(results);
            }
        });
    };
    /**
     * Init all cart events
     */
    AddressesSelection.prototype.initEvents = function () {
        var _this = this;
        /* Ajout d'une nouvelle adresse */
        this.$view.on('click', this.getSelectorAddAddress(), function (e) {
            e.preventDefault();
            _this.initAddressesModal($(e.target).closest(_this.getSelectorAddAddress()).attr('href'), function () {
                _this.initSelect2Countries();
                _this.initSelect2Cities();
                _this.hideLoader();
            });
        });
        /* Edition d'une adresse */
        this.$view.on('click', this.getSelectorEditAddress(), function (e) {
            e.preventDefault();
            _this.initAddressesModal($(e.target).closest(_this.getSelectorEditAddress()).attr('href'), function () {
                _this.initSelect2Countries();
                _this.initSelect2Cities();
                _this.hideLoader();
            });
        });
        /* Suppression d'une adresse */
        this.$view.on('click', this.getSelectorRemoveAddress(), function (e) {
            e.preventDefault();
            _this.deleteAddress($(e.target).closest(_this.getSelectorRemoveAddress()));
        });
    };
    return AddressesSelection;
}(BaseComponent_1.default));
exports.default = AddressesSelection;
;
